/** Textes « banque » — le français fait foi. */
export const banque = {
  titre: 'Banque',
  sousTitre: 'Le compte de l\'agence · distinct de la caisse, et il doit le rester',
  versementRetrait: 'Versement / retrait',
  fraisBancaires: 'Frais bancaires',
  totalBanque: 'Total en banque',
  mouvements: 'Mouvements du compte',
  videTitre: 'Aucun mouvement bancaire',
  videAction: 'Enregistrer un versement',
  videTexte: 'Déposez à la banque ce qui n\'a pas à rester en caisse. Chaque versement crée deux lignes — une sortie de caisse, une entrée en banque — pour que rien n\'apparaisse ni ne disparaisse.',
  colonnes: { date: 'Date', libelle: 'Libellé', reference: 'Référence', montant: 'Montant', par: 'Par' },
  note: 'Un versement apparaît des deux côtés : il sort de la caisse et entre en banque. Le total des deux poches ne change pas — c\'est ce qui permet de retrouver un écart.',
  transfert: {
    libelleDepot: 'Dépôt en banque',
    libelleRetrait: 'Retrait pour la caisse',
    depose: (m: string) => `${m} déposés en banque — la caisse a diminué d'autant.`,
    retire: (m: string) => `${m} retirés de la banque — la caisse a augmenté d'autant.`,
    impossible: 'Opération impossible',
    sens: 'Sens',
    versBanque: 'De la caisse vers la banque',
    versCaisse: 'De la banque vers la caisse',
    montant: (devise: string) => `Montant (${devise})`,
    reference: 'Référence',
    referenceAide: 'N° de bordereau, facultatif.',
    libelle: 'Libellé',
    deuxLignes: 'Deux lignes seront créées',
    explication: (versBanque: boolean) => `Une sortie de ${versBanque ? 'la caisse' : 'la banque'} et une entrée en ${versBanque ? 'banque' : 'caisse'}. L'argent ne peut ni apparaître ni disparaître.`,
  },
  frais: {
    libelleDefaut: 'Frais de tenue de compte',
    enregistres: (m: string) => `Frais bancaires enregistrés — ${m}.`,
    impossible: 'Enregistrement impossible',
    explication: 'Ils sortent du compte, pas de la caisse : la caisse n\'est pas touchée.',
  },
};
